import { Delivery } from "../domain/deliveries";
import { getAllDeliveriesService } from "../infrastructure/services/getAllDeliveriesService";

export const getAllDeliveries = {
  async execute(): Promise<Delivery[]> {
    return await getAllDeliveriesService.execute();
  },
};


